// Auto generated file, do not manually modify!
// com.hotpads.yourrentalapi.enums.CtaType

export enum CtaType {
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TEXT_BUTTON = 'TEXT_BUTTON',
}

export const CtaType_values = [CtaType.PRIMARY_BUTTON, CtaType.SECONDARY_BUTTON, CtaType.TEXT_BUTTON] as const;
